import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SharedDataService} from '../../provider/shared-data/shared-data.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {StorageService} from '../../provider/storage/storage.service';
import {
	APP_CONDITION_ITEMS, APP_ROUTES,
	APP_STORAGE,
	IQAPI_ROUTES
} from '../../../environments/environment';
import {
	ConfigurationObject,
	GetList,
	SearchQueryParams,
	TypAuswahlFeldListe
} from '../../interfaces/interfaces.regisafe';
import {IonSelect, ModalController} from '@ionic/angular';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {NavigationExtras, Router} from '@angular/router';
import {UserService} from '../../provider/user/user.service';
import {AppConfig} from '../../app.config';
import {ListeArtComponent} from './liste-art/liste-art.component';
import {Observable} from 'rxjs';


@Component({
	selector: 'app-regisafe-search-forms',
	templateUrl: './regisafe-search-forms.component.html',
	styleUrls: ['./regisafe-search-forms.component.scss'],
})
export class RegisafeSearchFormsComponent implements OnInit, OnChanges {

	@Input() searchFormAction: any;
	@ViewChild('itemList', {static: true}) itemListRef: IonSelect;
	@ViewChild('itemListArt', {static: true}) itemListArtRef: IonSelect;

	public configuration: ConfigurationObject;
	public shared: any;
	public searchForms: any = {};
	public searchFormsDefault: any = {};
	public searchFormsData: any;
	public orgaStructures = [];
	public orgaStructuresDefault = [];

	public listItems = [];
	public listItemsArt = [];
	public currentListField = null;
	public currentListFieldValue = [];
	public selectetdValues = {};

	constructor(private httpClient: HttpClient,
				public sharedService: SharedDataService,
				private storageService: StorageService,
				private errorHandling: ErrorHandlingService,
				private router: Router,
				private userService: UserService,
				public appConfig: AppConfig,
				private modalCtrl: ModalController) {

		this.configuration = this.appConfig.getConfig();
	}
	/**
	 *
	 */
	async ngOnInit() {
		this.shared = this.sharedService.getRegisafeGlobalData();
		this.searchFormsData = await this.storageService.getSearchFormData();

		const orgaStructsAllFromConditions = await this.storageService.getConditions(APP_CONDITION_ITEMS.orgaStructs);
		const orgaStructsAll = [];
		Object.keys(orgaStructsAllFromConditions).forEach((structure) => {
			orgaStructsAll[orgaStructsAllFromConditions[structure].osIndex] = orgaStructsAllFromConditions[structure].osId;
		});

		await this.generateSearchForms(orgaStructsAll);
	}

	/**
	 *
	 * @param changes
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes.hasOwnProperty('searchFormAction')) {
			if (changes.searchFormAction.currentValue.searchAction === 'search') {
				this.submitForm(this.shared.orgastruktur);
			}
			if (changes.searchFormAction.currentValue.searchAction === 'reset') {
				this.resetForm();
			}
		}
	}

	destroyToast() {
		// this.errorHandling.toast.dismiss();
	}


	/**
	 * generateSearchForms()
	 *
	 * Alle in den Conditions enthaltenen OrgaStrukturen (orgaStructs) werden an die Methode übergeben. Über eine Schleife (forEach)
	 * wird verglichen welche Strukturen sich in den in der Datenbank gespeicherten JSON Daten (searchFormsData) befinden und den
	 * Formularen (searchForms) zugeordnet.
	 * OrgaStrukturen die nicht enthalten sind werden separat behandelt und entsprechend 'searchFormsDefault' zugeordnet.
	 *
	 * @param orgaStructsAll
	 */
	async generateSearchForms(orgaStructsAll) {

		Object.keys(orgaStructsAll).forEach((structure) => {
			if (this.searchFormsData.hasOwnProperty(orgaStructsAll[structure])) {
				this.orgaStructures.push(orgaStructsAll[structure]);
				this.searchForms = Object.assign(this.searchForms, {[orgaStructsAll[structure]]: FormGroup});
			} else {
				this.orgaStructuresDefault.push(orgaStructsAll[structure]);
				this.searchFormsDefault = Object.assign(this.searchFormsDefault, {[orgaStructsAll[structure]]: FormGroup});
			}
		});

		// Default for 'unknown' OrgaStructs
		this.orgaStructuresDefault.forEach((structure: string) => {

			// generate Fields
			if (this.searchFormsData.hasOwnProperty('default')) {
				const formGroup = {};
				const subformGroup = {};
				this.searchFormsData.default.formFields.forEach((formField) => {

					let validatorOpt = null;
					if (formField.required) {
						validatorOpt = [Validators.required, Validators.minLength(formField.minLength)];
					}

					if (typeof formField.name !== 'undefined') {
						formGroup[formField.name] = new FormControl({}, validatorOpt);
					}
				});

				// create Form
				this.searchFormsDefault[structure] = new FormGroup(formGroup);

				// add Values to Fields
				this.searchFormsData.default.formFields.forEach((field) => {
					if (typeof field.name !== 'undefined') {
						this.searchFormsDefault[structure].controls[field.name].setValue(field.value);
					}
				});

			}
		});

		// From defined SearchForms
		this.orgaStructures.forEach((structure: string) => {
			if (this.searchFormsData.hasOwnProperty(structure)) {
				const formGroup = {};
				const subformGroup = {};

				// generate Fields
				this.searchFormsData[structure].formFields.forEach((formField) => {

					let validatorOpt = null;
					if (formField.required) {
						validatorOpt = [Validators.required, Validators.minLength(formField.minLength)];
					}

					if (typeof formField.name !== 'undefined') {
						formGroup[formField.name] = new FormControl({}, validatorOpt);
					} else if (typeof formField.groupname !== 'undefined') {

						formField.fields.forEach((subfield) => {
							subformGroup[subfield.name] = new FormControl({});
						});

						formGroup[formField.groupname] = new FormGroup(subformGroup);
					}
				});

				// create Form
				this.searchForms[structure] = new FormGroup(formGroup);

				// add Values to Fields
				this.searchFormsData[structure].formFields.forEach((field) => {
					if (typeof field.name !== 'undefined') {
						this.searchForms[structure].controls[field.name].setValue(field.value);
					} else if (typeof field.groupname !== 'undefined') {
						field.fields.forEach((subfield) => {

							let value = '';
							if (subfield.type === 'Datum' && subfield.value !== '') {
								value = this.userService.formatDate(subfield.value);
							} else {
								value = subfield.value;
							}
							this.searchForms[structure].controls[field.groupname].controls[subfield.name].setValue(value);
						});
					}
				});

			}
		});


	}

	/**
	 * onChangeSearchValue()
	 *
	 * Liest den wert des aktuell gewählten Suchfeldes (searchText) aus und übergibt diesen an
	 * alle anderen Suchfelder. Der Benutzer muss so bei einem Wechsel zwischen den Orgastrukturen
	 * nicht jedes mal den Suchbegriff erneut eingeben
	 *
	 * @param event
	 */
	public onChangeSearchValue(event) {
		const searchValue = event.detail.value;
		Object.keys(this.searchForms).forEach((key) => {
			this.searchForms[key].controls.searchText.setValue(searchValue);
		});
		Object.keys(this.searchFormsDefault).forEach((key) => {
			this.searchFormsDefault[key].controls.searchText.setValue(searchValue);
		});
	}

	public onChange(event) {

	}

	/**
	 *
	 * @param formName
	 * @private
	 */
	public async submitForm(formName) {
		if (this.searchForms[formName]) {
			if (this.searchForms[formName].valid) {
				this.buildQueryParamsAndNavigate(this.searchForms[formName].value);
			} else {
				console.log('MinL?: ', this.searchForms[formName].controls.searchText.errors);
			}
		} else {
			if (this.searchFormsDefault[formName].valid) {
				this.buildQueryParamsAndNavigate(this.searchFormsDefault[formName].value);
			} else {
				console.log('MinL?: ', this.searchFormsDefault[formName].controls.searchText.errors);
			}
		}

	}

	submitFormViaEnter(event, formName) {
		this.submitForm(formName);
	}


	/**
	 * buildQueryParamsAndNavigate()
	 *
	 * @param formValue
	 * @private
	 */
	public async buildQueryParamsAndNavigate(formValue: any) {

		// searchFields auf "ArtID" prüfen und ggf. umschreiben (name -> artId)
		const rewritedFormValues = await this.rewriteArtIdsInFormValues(formValue);
		console.log('rewritedFormValues: ', rewritedFormValues);
		if (rewritedFormValues) {
			formValue = rewritedFormValues;
		}

		const searchFieldsParams = {};
		if (formValue.hasOwnProperty('searchFields')) {
			Object.entries(formValue.searchFields).forEach((item: [string, string]) => {
				searchFieldsParams[item[0]] = item[1].trim();
			});
		}

		let defaultSortFields = '';
		const defaultSortingFieldsObj = await this.storageService.getSortingData();
		const sortingDataSelection = await this.storageService.getSortingDataSelection();
		let index = 0;



		console.log('##### : ', sortingDataSelection);
		console.log('##### : ', index);
		console.log('##### : ', defaultSortingFieldsObj);
		console.log('##### : ', defaultSortingFieldsObj.Default);
		console.log('##### : ', defaultSortingFieldsObj.Default[index]);
		console.log('##### : ', this.shared.orgastruktur);


		if (defaultSortingFieldsObj.hasOwnProperty(this.shared.orgastruktur)) {
			if (sortingDataSelection) {
				index = sortingDataSelection[this.shared.orgastruktur];
			}
			defaultSortFields = defaultSortingFieldsObj[this.shared.orgastruktur][index].value;
		} else {
			if (sortingDataSelection) {
				index = sortingDataSelection.Default;
			}
			defaultSortFields = defaultSortingFieldsObj.Default[index].value;
		}

		const base64encodedSearchFields = btoa(JSON.stringify(searchFieldsParams));
		const searchQueryParams: SearchQueryParams = {
			osId: this.shared.orgastruktur,
			searchText: formValue.searchText.trim(),
			searchFields: base64encodedSearchFields,
			navigationTarget: APP_ROUTES.suche,
			sortFields: defaultSortFields
		};

		const navigationExtras: NavigationExtras = {
			queryParams: searchQueryParams,
		};

		this.router.navigate([APP_ROUTES.suchergebnisse], navigationExtras)
			.then((navigated) => {
				// do something or leave it
			});
	}

	async rewriteArtIdsInFormValues(formValue): Promise<any> {
		console.log('formValue: ', formValue);
		if (formValue.hasOwnProperty('searchFields')) {
			if (formValue.searchFields.hasOwnProperty('ArtID')) {
				if (formValue.searchFields.ArtID.length > 0) {

					const artIdValues = formValue.searchFields.ArtID.split(';');
					const orgaStructs = await this.storageService.getConditions('orgaStructs');
					const osArts = orgaStructs[this.shared.orgastruktur].osArts;

					const filteredArtIds = [];
					if (artIdValues.length > 0) {
						artIdValues.forEach((item, index) => {
							const filtered = osArts.filter((object) => object.name === item);
							console.log('----- filtered: ', filtered);
							filteredArtIds.push(filtered[0].artId);
						});
						formValue.searchFields.ArtID = filteredArtIds.join(';');
						return formValue;
					}
				}
			}
		}
		return false;
	}

	/**
	 * Setzt die Suchmaske vollständig zurück
	 *
	 * @private
	 */
	public async resetForm() {
		this.searchForms = {};
		this.orgaStructures = [];
		const appStructsFromConditions = await this.storageService.getConditions(APP_CONDITION_ITEMS.appStructs);
		this.searchFormsData = await this.storageService.getSearchFormData();
		await this.generateSearchForms(appStructsFromConditions);
	}

	/**
	 * getList(event, listName: string, multiple: boolean = false, header: string, fieldname: string)
	 *
	 * Holt die zum Feld zugehörige Auswahlfeldliste über die IQAPI und übergibt diese an
	 * ein modales Fenster. Dort wird die Liste zur Auswahl für den Benutzer angeboten und
	 * nach Abschluss an das Eingabefeld als String übergeben (bei Mehrfachauswahl semikolon-separiert).
	 *
	 * @param event
	 * @param listName
	 * @param multiple
	 * @param header
	 * @param fieldname
	 */
	public async getList(event, listName: string, multiple: boolean = false, header: string, fieldname: string) {
		this.currentListField = event.target.name;
		this.currentListFieldValue = event.target.value;
		// this.itemListRef.value = this.currentListFieldValue;

		const options: object = {headers: {}, responseType: 'json', reportProgress: true, observe: 'response'};
		const body: GetList = {
			apiID: this.configuration.iqapiAppId,
			sessionToken: localStorage.getItem(APP_STORAGE.tokenname),
			getList: 1,
			getItems: 0,
			name: listName
		};
		this.httpClient.post(this.configuration.iqapiEndpoint + IQAPI_ROUTES.getList, body, options).subscribe(
			(result: any) => {
				// this.openItemList(result.body.list, multiple, header, fieldname);
				this.openModal(result.body.list, multiple, header, fieldname, event.target.value, 'simplelist');
			}, (error) => {
				console.log('getList error: ', error);
				this.errorHandling.handleError(error, 'RegisafeSearchFormsComponent -> getList');
			}
		);
	}

	/**
	 * getListArt(event, listName: string, multiple: boolean = false, header: string, fieldname: string)
	 *
	 * Liest die zur Orgastruktur zugehörigen osArts als Liste aus und übergibt diese an
	 * ein modales Fenster. Dort wird die Liste zur Auswahl für den Benutzer angeboten und
	 * nach Abschluss an das Eingabefeld als String übergeben  (bei Mehrfachauswahl semikolon-separiert).
	 *
	 * @param event
	 * @param listName
	 * @param multiple
	 * @param header
	 * @param fieldname
	 */
	public async getListArt(event, listName: string, multiple: boolean = false, header: string, fieldname: string) {
		const orgaStructs = await this.storageService.getConditions('orgaStructs');
		const osArts = orgaStructs[this.shared.orgastruktur].osArts;

		this.currentListField = event.target.name;
		this.currentListFieldValue = event.target.value;
		// this.itemListArtRef.value = this.currentListFieldValue;
		// this.openItemListArt(osArts, multiple, header, fieldname);
		this.openModal(osArts, multiple, header, fieldname, event.target.value, 'objectlist');

	}

	/**
	 * openModal()
	 *
	 * Öffnet ein modales Fenster für die zur Benutzerauswahl übergebenen Liste. Die Rückgabe
	 * aus dem Fenster wird nach Schließen an das Eingabefeld im Suchformular übergeben
	 *
	 * @param list
	 * @param multiple
	 * @param header
	 * @param fieldname
	 * @param value
	 * @param type
	 */
	// eslint-disable-next-line max-len
	async openModal(list: Array<string>, multiple: boolean, header: string, fieldname: string, value: any, type: TypAuswahlFeldListe): Promise<any> {
		const props = {
			list,
			multiple,
			header,
			fieldname,
			value,
			type
		};
		const modal = await this.modalCtrl.create({
			component: ListeArtComponent,
			componentProps: props,
			backdropDismiss: false
		});
		await modal.present();

		return modal.onDidDismiss().then((response) => {
			const artListArr: Array<string> = [];
			response.data.forEach((item) => {
				artListArr.push(item.name);
			});

			const artList = artListArr.join(';');

			this.searchForms[this.shared.orgastruktur].controls.searchFields.controls[this.currentListField].setValue(artList);
			this.selectetdValues[this.currentListField] = artList;
		});

	}

	/**
	 * setItem()
	 *
	 * wird im onChange-Event des versteckten Select-Feldes '#itemList' aufgerufen und übergibt den/die gewählten
	 * Wert(e) an das vorab gewählte Eingabe-Feld 'currentListField'
	 *
	 * @param event
	 * @private
	 */
	private setItem(event) {
		let value = event.target.value;
		if (typeof value === 'object') {
			value = value.join(';');
		}

		this.searchForms[this.shared.orgastruktur].controls.searchFields.controls[this.currentListField].setValue(value);
		this.selectetdValues[this.currentListField] = value;
	}

	// private setItemArt(event) {
	//
	// 	console.log('setItemArt: ', event);
	// 	let value = event.target.value;
	// 	if (typeof value === 'object') {
	// 		value = value.join(';');
	// 	}
	//
	// 	this.searchForms[this.shared.orgastruktur].controls.searchFields.controls[this.currentListField].setValue(value);
	// 	this.selectetdValues[this.currentListField] = value;
	// }

	/**
	 * openItemList()
	 *
	 * setzt Titel, Mehfachauswahl und Wert(e) des versteckten Select-Feldes '#itemList'
	 * und öffnet es.
	 *
	 * @param list
	 * @param multiple
	 * @param header
	 * @param fieldname
	 * @private
	 */
	private openItemList(list: Array<string>, multiple: boolean, header: string, fieldname: string) {

		this.listItems = list;

		if (this.listItems.length > 0) {
			setTimeout(() => {
				this.itemListRef.interfaceOptions.header = header;
				this.itemListRef.multiple = multiple;
				try {
					this.itemListRef.value = this.selectetdValues[fieldname].split(';');
				} catch (e) {
					this.itemListRef.value = '';
				}

				// Select-Feld öffnen
				this.itemListRef.open();
			}, 100);
		}
	}

	//
	// private openItemListArt(list: Array<string>, multiple: boolean, header: string, fieldname: string) {
	//
	// 	this.listItemsArt = list;
	//
	// 	if (this.listItemsArt.length > 0) {
	// 		setTimeout(() => {
	// 			this.itemListArtRef.interfaceOptions.header = header;
	// 			this.itemListArtRef.multiple = multiple;
	// 			try {
	// 				this.itemListArtRef.value = this.selectetdValues[fieldname].split(';');
	// 			} catch (e) {
	// 				this.itemListArtRef.value = '';
	// 			}
	//
	// 			// Select-Feld öffnen
	// 			this.itemListArtRef.open();
	// 		}, 100);
	// 	}
	// }

}
